import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Modal, TextContainer, Banner } from '@shopify/polaris';

const propTypes = {
  // onClose: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onAction: PropTypes.func.isRequired,

  open: PropTypes.bool.isRequired,
};

const defaultProps = {

}


const OrderSupplyConfirmationModal = (props) => (
  <Modal
    title="Confirmar creación"
    large
    open={props.open}
    primaryAction={{
      content: I18n.t("actions.confirm"),
      onAction: props.onAction,
      loading: props.loading
    }}
    secondaryActions={[
      { 
        content: I18n.t("actions.cancel"),
        onAction: props.onCancel,
        loading: props.loading
      },
    ]
  }
  >
    <TextContainer>
      <Banner status="warning">
        <p>
          { I18n.t("app.messages.confirm_order_supply_without_seller") }
        </p>
      </Banner>
    </TextContainer>
  </Modal>
);

OrderSupplyConfirmationModal.propTypes = propTypes;
OrderSupplyConfirmationModal.defaultProps = defaultProps;

export default OrderSupplyConfirmationModal;